// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录入口
import login from '@/views/login';

// 用户登录
import userLogin from '@/views/login/userLogin';
// 用户注册
import userRegister from '@/views/login/userRegister';
// 专家登录
import agentLogin from '@/views/login/agentLogin';
// 管理登录
import adminLogin from '@/views/login/adminLogin';
// 首页
import index from '@/views/index';
// 首页
import webIndex from '@/views/index/index';

/**
 * 用户端
 */
// 申请评估
import applyEval from '@/views/customer/applyEval';
// 评估记录
import evalRecord from '@/views/customer/evalRecord';
// 草稿箱
import applyDrafts from '@/views/customer/applyDrafts';
// 个人中心
import personCenter from '@/views/customer/personCenter';

/**
 * 专家端
 */
// 待评估
import waitEval from '@/views/agent/waitEval';
// 专家撰写
import writeEval from '@/views/agent/writeEval';
// 评估记录
import agentEvalRecord from '@/views/agent/agentEvalRecord';
// 个人中心
import agentPersonCenter from '@/views/agent/agentPersonCenter';

/**
 * 管理端
 */
// 账户管理
import sysAccount from '@/views/system/account';
// 案件管理
import sysCase from '@/views/system/case';
// 个人中心
import sysPersonCenter from '@/views/system/personCenter';
// 平台图表
import sysPlatformChart from '@/views/system/platformChart';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: webIndex,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: 'login',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
      path: '/index/index',
      name: 'webIndex',
      component: webIndex,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/userLogin',
      name: 'userLogin',
      component: userLogin,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/userRegister',
      name: 'userRegister',
      component: userRegister,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/agentLogin',
      name: 'agentLogin',
      component: agentLogin,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/adminLogin',
      name: 'adminLogin',
      component: adminLogin,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
        path: '/index',
        name: 'index',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
          {
            path: '/customer/applyEval',
            name: '申请评估',
            component: applyEval,
            meta: {
                requireAuth: true
            }
          },{
            path: '/customer/evalRecord',
            name: '评估记录',
            component: evalRecord,
            meta: {
                requireAuth: true
            }
          },{
            path: '/customer/applyDrafts',
            name: '草稿箱',
            component: applyDrafts,
            meta: {
                requireAuth: true
            }
          },{
            path: '/customer/personCenter',
            name: '个人中心',
            component: personCenter,
            meta: {
                requireAuth: true
            }
          },{
            path: '/agent/waitEval',
            name: '待评估',
            component: waitEval,
            meta: {
                requireAuth: true
            }
          },{
            path: '/agent/writeEval',
            name: '专家撰写',
            component: writeEval,
            meta: {
                requireAuth: true
            }
          },{
            path: '/agent/agentEvalRecord',
            name: '专家记录',
            component: agentEvalRecord,
            meta: {
                requireAuth: true
            }
          },{
            path: '/agent/agentPersonCenter',
            name: '个人中心',
            component: agentPersonCenter,
            meta: {
                requireAuth: true
            }
          },{
            path: '/system/account',
            name: '帐户管理',
            component: sysAccount,
            meta: {
                requireAuth: true
            }
          },{
            path: '/system/case',
            name: '案件管理',
            component: sysCase,
            meta: {
                requireAuth: true
            }
          },{
            path: '/system/personCenter',
            name: '个人中心',
            component: sysPersonCenter,
            meta: {
                requireAuth: true
            }
          },{
            path: '/system/platformChart',
            name: '平台图表',
            component: sysPlatformChart,
            meta: {
                requireAuth: true
            }
          }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js